<template>
  <div id="guide" class="guide-container flex flex-direction">
    <div class="top">
      <Title :ch="'参会指南'" :bg-img="titleBgImg"></Title>
    </div>
    <div class="guide-box">
      <img
        @click="lookMore"
        class="guide-mobile-image"
        src="../assets/images/guide-mobile.png"
      />
      <img
        @click="lookMore"
        class="guide-pc-image"
        src="../assets/images/guide-pc.png"
      />
      <!--            <div class="link flex align-center justify-center cs">-->
      <!--              <span @click="lookMore"> 查看更多 >></span>-->
      <!--            </div>-->
      <DidLink
        style="margin-top: 15px"
        :text="'查看地图'"
        @click.native="gotoMap"
      ></DidLink>
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
import { $config } from "../conf";

export default {
  name: "Guide",
  data() {
    return {
      titleBgImg: require("../assets/images/wap/title/guide.png"),
    };
  },
  components: {
    Title,
  },
  mounted() {},
  methods: {
    gotoMap: function () {
      window.open($config.mapUrl);
      //埋码
      window._hw("send", "action", "index_meeting_map_click");
    },
    lookMore() {
      //埋码
      window._hw("send", "action", "index_meeting_guide_click");
      this.$router.push({
        path: "/guide",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.guide-container {
  padding-top: 60px;
  padding-bottom: 60px;
  .top {
    margin-left: 160px;
    width: 1158px;
    height: 140px;
  }
  .guide-box {
    .guide-pc-image {
      margin: 0 auto;
      cursor: pointer;
      width: 1425px;
      display: block;
    }
    .guide-mobile-image {
      display: none;
    }
  }
}
@media screen and (max-width: 992px) {
  .guide-container {
    padding-top: 143px;
    padding-bottom: 60px;
    .top {
      margin-left: 0;
      width: 100%;
      height: 56px;
    }
    .guide-box {
      margin-top: 27px;
      .guide-pc-image {
        display: none;
      }
      .guide-mobile-image {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>
